import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'PlatformService'
const host = servicesConfig.Platform
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const PlatformService = {
  getPlatformTest: async () => {
    return request().get(`/`).then(responseBody)
  }
}

export default PlatformService
